import React, { useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import RadioButtonAtm from "../../atoms/RadioButtonAtm";
import TextAtm from "../../atoms/TextAtm";
import PushOrg from "../../organisms/PushOrg";
import { RadioBoxContainer, AsideContainer, FlexContainer, InnerContainer, RadioButtonContainer, TopLabelContainer, CoinsIcon } from "./RadioBoxMol.styled";
var LabelContainer = function LabelContainer(_ref) {
  var topLabel = _ref.topLabel,
    topLabelBackgroundColor = _ref.topLabelBackgroundColor;
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(TopLabelContainer, {
    $topLabelBackgroundColor: topLabelBackgroundColor
  }, /*#__PURE__*/React.createElement(CoinsIcon, {
    $onColor: onColor
  }), topLabel);
};
function RadioBoxMol(_ref2) {
  var isChecked = _ref2.isChecked,
    text = _ref2.text,
    aside = _ref2.aside,
    topLabel = _ref2.topLabel,
    _ref2$topLabelBackgro = _ref2.topLabelBackgroundColor,
    topLabelBackgroundColor = _ref2$topLabelBackgro === void 0 ? "notifyLight" : _ref2$topLabelBackgro,
    bottomLabel = _ref2.bottomLabel,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(RadioBoxContainer, {
    $isChecked: isChecked,
    onClick: onChange
  }, topLabel ? /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: topLabelBackgroundColor
  }, /*#__PURE__*/React.createElement(LabelContainer, {
    topLabel: topLabel,
    topLabelBackgroundColor: topLabelBackgroundColor
  })) : undefined, /*#__PURE__*/React.createElement(InnerContainer, {
    gapSpace: 1,
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FlexContainer, {
    flexBasis: "auto",
    flexShrink: 0,
    $hasBottomLabel: !!bottomLabel
  }, bottomLabel ? /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 1
  }, bottomLabel) : undefined, /*#__PURE__*/React.createElement(RadioButtonContainer, {
    gapSpace: 2
  }, /*#__PURE__*/React.createElement(RadioButtonAtm, {
    isChecked: isChecked,
    onChange: onChange,
    hasExpandedClickField: true
  }), /*#__PURE__*/React.createElement(TextAtm, {
    typography: "medium3_h"
  }, text))), /*#__PURE__*/React.createElement(AsideContainer, {
    flexShrink: 1,
    flexGrow: 1
  }, aside)));
}
export default RadioBoxMol;